import { Controller } from "@hotwired/stimulus"
import { Tooltip } from "bootstrap"

// Les infobulles du catalogue (fiche du produit et de l'étage, Cycle de vie et ses panneaux, index) : chaque attribut
// title de la zone devient l'infobulle Bootstrap de l'application (celle du contrôleur tooltips et de l'aide tooltipize,
// classe custom-tooltip), affichée tout de suite au survol et au focus clavier, au lieu de l'infobulle native du
// navigateur, lente. Le contenu chargé ensuite (frames, panneaux) est pris en charge à son arrivée (MutationObserver).
// Un élément sans focus naturel qui porte une infobulle devient atteignable au clavier (tabindex 0).
// data-tooltip-if-truncated : un texte coupé par une ellipse, dont l'infobulle le donne en entier ; elle ne s'affiche que
// s'il est vraiment coupé.
const SKIP = "iframe, svg, option, [data-bs-toggle], [data-controller~='tooltips'], [data-no-tooltip]"
const INTERACTIVE = "a[href], button, input, select, textarea, summary, [tabindex]"

export default class extends Controller {
  connect() {
    this.upgrade(this.element)
    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) this.upgrade(node)
      }))
    })
    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  disconnect() {
    this.observer?.disconnect()
    this.element.querySelectorAll("[data-insurance-catalog-tooltip]").forEach((element) => Tooltip.getInstance(element)?.dispose())
  }

  upgrade(root) {
    const elements = root.matches?.("[title]") ? [root, ...root.querySelectorAll("[title]")] : root.querySelectorAll("[title]")
    elements.forEach((element) => {
      if (!element.getAttribute("title") || element.matches(SKIP) || element.closest("svg")) return

      const truncatable = element.hasAttribute("data-tooltip-if-truncated")
      if (truncatable && !("insuranceCatalogTooltip" in element.dataset)) {
        element.addEventListener("show.bs.tooltip", (event) => {
          if (element.scrollWidth <= element.clientWidth) event.preventDefault()
        })
      }
      element.dataset.insuranceCatalogTooltip = ""
      if (!truncatable && !element.matches(INTERACTIVE) && !element.querySelector(INTERACTIVE)) element.tabIndex = 0
      Tooltip.getOrCreateInstance(element, { delay: 0, trigger: "hover focus", customClass: "custom-tooltip", container: "body" })
    })
  }
}
